<template>
  <svg
    id="mic-indicator"
    xmlns="http://www.w3.org/2000/svg"
    width="14.4"
    height="20.801"
    viewBox="0 0 14.4 20.801"
  >
    <g id="グループ_375" data-name="グループ 375" transform="translate(-1220.8 -325.599)">
      <g id="ベクトルスマートオブジェクト" transform="translate(-1 -800)">
        <g
          id="ベクトルスマートオブジェクト-2"
          data-name="ベクトルスマートオブジェクト"
          transform="translate(910.2 533.2)"
        >
          <g id="グループ_53" data-name="グループ 53">
            <path
              id="パス_89"
              data-name="パス 89"
              d="M318,609.938V611.6h-1.2a.8.8,0,1,0,0,1.6h4a.8.8,0,0,0,0-1.6h-1.2v-1.662A7.76,7.76,0,0,0,326,602.8a.8.8,0,0,0-1.6,0,5.6,5.6,0,1,1-11.2,0,.8.8,0,0,0-1.6,0A7.76,7.76,0,0,0,318,609.938Z"
            />
            <path
              id="パス_90"
              data-name="パス 90"
              d="M318.8,606.8a4,4,0,0,0,4-4v-6.4a4,4,0,0,0-8,0v6.4A4,4,0,0,0,318.8,606.8Zm0-12.8a2.4,2.4,0,0,1,2.4,2.4v.4h-.8a.8.8,0,0,0,0,1.6h.8V600h-.8a.8.8,0,0,0,0,1.6h.8v1.2a2.4,2.4,0,1,1-4.8,0v-1.2h.8a.8.8,0,0,0,0-1.6h-.8v-1.6h.8a.8.8,0,0,0,0-1.6h-.8v-.4A2.4,2.4,0,0,1,318.8,594Z"
            />
          </g>
        </g>
        <path
          id="Color_Overlay"
          data-name="Color Overlay"
          d="M1227,1146.4a.8.8,0,1,1,0-1.6h1.2v-1.663a7.759,7.759,0,0,1-6.4-7.137.8.8,0,0,1,1.6,0,5.6,5.6,0,1,0,11.2,0,.8.8,0,0,1,1.6,0,7.759,7.759,0,0,1-6.4,7.137v1.663h1.2a.8.8,0,1,1,0,1.6Zm-2-10.4v-6.4a4,4,0,1,1,8,0v6.4a4,4,0,0,1-8,0Zm1.6,0a2.4,2.4,0,0,0,4.8,0v-1.2h-.8a.8.8,0,1,1,0-1.6h.8v-1.6h-.8a.8.8,0,1,1,0-1.6h.8v-.4a2.4,2.4,0,1,0-4.8,0v.4h.8a.8.8,0,1,1,0,1.6h-.8v1.6h.8a.8.8,0,1,1,0,1.6h-.8Z"
          fill="#fff"
        />
      </g>
      <rect
        id="長方形_56"
        data-name="長方形 56"
        width="8"
        :height="volume"
        rx="4"
        transform="rotate(180) translate(-1232 -340)"
        fill="#fff"
      />
    </g>
  </svg>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  data() {
    return {
      volume: 0,
      audioContext: null,
      volumeInterval: null,
      microphoneSource: null,
      javascriptNode: null
    };
  },
  mounted() {
    if (this.localUser?.stream && !this.hasMicError) {
      this.setMicLevel();
    }
  },
  computed: {
    ...mapState(['provider']),
    ...mapState('videoRtc', ['localUser', 'activeAudioTrack']),
    ...mapGetters('devices', ['hasMicError']),
  },
  methods: {
    async setMicLevel() {
      clearInterval(this.volumeInterval);

      let soundVol = 0;
      if (!this.audioContext) {
        this.audioContext = new AudioContext();
      }
      // disconnect on change of audio
      if (this.microphoneSource) {
        this.microphoneSource.disconnect(analyser);
        this.javascriptNode.disconnect(this.audioContext.destination);
      }
      let analyser = this.audioContext.createAnalyser();
      this.microphoneSource = this.audioContext.createMediaStreamSource(this.localUser.stream);

      await this.audioContext.audioWorklet.addModule('/MyStage/js/volume-unit-meter.js');
      this.javascriptNode = new AudioWorkletNode(this.audioContext, 'volume-unit-meter');

      // setup analyzer
      analyser.smoothingTimeConstant = 0.3;
      analyser.fftSize = 1024;

      // connect the source to analyzer
      this.microphoneSource.connect(analyser);
      analyser.connect(this.javascriptNode);

      let vm = this;

      this.javascriptNode.port.onmessage = (event) => {
        let sensibility = 5;
        if (event.data.volume) this.volume = event.data.volume;
        this.volume = (this.volume * 100) / sensibility;
      };

      this.microphoneSource.connect(this.javascriptNode).connect(this.audioContext.destination);

      this.volumeInterval = setInterval(() => {
        vm.volume = soundVol >= 14 ? 14 : soundVol;
      }, 350);
    }
  },
  watch: {
    isLessonEnded(state) {
      if (state) {
        clearInterval(this.volumeInterval);
      }
    }
  }
};
</script>
